"use strict";
exports.__esModule = true;
//# sourceMappingURL=slider-hero-slice.js.map